// extracted by mini-css-extract-plugin
export default {"common":"XwtJj","icon":"ngGSR"};